import React, {ReactNode, ReactNodeArray} from 'react';
import EpiComponent from '@episerver/spa-core/EpiComponent';
import IFrameGeneralBlockData from '../../../Models/Content/IFrameGeneralBlockData';
import IFrameGeneralWrapperComponent from './IFrameGeneralWrapperComponent';

export default class IFrameGeneralBlock extends EpiComponent<IFrameGeneralBlockData> {
  public render(): ReactNode | ReactNodeArray | null {
    return <IFrameGeneralWrapperComponent iContent={this.props.data} context={this.getContext()} />;
  }
}
